import { Injectable } from '@angular/core';
import { SettingsService } from './settings/settings.service';

@Injectable({
    providedIn: 'root',
})
export class ThirdPartyAppsFeatureService {
    private static readonly EnabledSettingKey = 'ThirdPartyApps.Enabled';

    constructor(private readonly settingsService: SettingsService) {
    }

    isEnabled(): boolean {
        const setting = this.settingsService.getSetting(ThirdPartyAppsFeatureService.EnabledSettingKey);
        if (!setting) {
            return false;
        }

        // This is a global kill switch. User-specific values must not re-enable
        // third-party apps for root/admin accounts when the system setting is off.
        return this.parseEnabled(setting.primaryValue ?? setting.defaultValue);
    }

    private parseEnabled(value: unknown): boolean {
        if (value === null || value === undefined || value === '') {
            return false;
        }

        if (typeof value === 'boolean') {
            return value;
        }

        return !['false', '0', 'no', 'off', 'disabled'].includes(String(value).trim().toLocaleLowerCase());
    }
}
